import { Component } from '@angular/core';

@Component({
  templateUrl: './admin.page.html',
})
export class AdminPageComponent {}
